import {
  Autocomplete,
  Card,
  CardHeader,
  Dialog,
  IconButton,
  MenuItem,
  Tab,
  Tabs,
  Tooltip,
  tabsClasses,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { SyntheticEvent, useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  InputAdornment,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  useDeleteProductMutation,
  useGetProductQuery,
  useGetProductCategoryQuery,
  useGetCategoryQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
  useCreatePriceCheckListMutation,
  useGetLastPriceCheckListIdQuery,
  useGetBrandQuery,
  useGetTagQuery,
  useGetMainItemQuery,
  useGetRestaurantQuery,
  useGetCapacityQuery,
  useGetGradeQuery,
  useGetSupplierQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IOrderItem,
  IOrderItemSetUp,
  IProductCategory,
  IVariantView,
  IBrand,
  ITag,
  IMainItem,
  CustomerOption,
  IRestaurant,
  ICapacity,
  IPriceCheckList,
  CustomerOptionString,
  IGrade,
  ISupplier,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import dayjs, { Dayjs } from "dayjs";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import { useFormik } from "formik";
import { Privileges, SizeOfLevelType } from "../../../Core/Enum/enum";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { CiEdit } from "react-icons/ci";
import NewPopUpProduct from "../../Product/Edit/index";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import NewColor from "../../ThemeColor/Component/index";
import RefreshIcon from "@mui/icons-material/Refresh";
import useUser from "../../../Core/hook/useUser";
import ClassRoundedIcon from "@mui/icons-material/ClassRounded";
import RemoveIcon from "@mui/icons-material/Remove";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { capitalizeFirstLetter } from "../../../Components/Validation/capitalizeFirstLetter";
import useIsMobile from "../../../Core/hook/useIsMobile";
import NewProductSupplier from "../../Supplier/Edit/index";
import NewProductGrade from "../../Grade/Edit/index";

const generateWorkOrderNumber = (workOrderId: number) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `OL${year}${month}${day}-${workOrderId.toString().padStart(2, "0")}`;
};

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { userHasRight } = useUser();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const getFormattedDate = (createDate: Dayjs | null): string => {
    return createDate ? createDate.format("YYYY-MM-DD") : "";
  };
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [selectedProductBrandId, setSelectedProductBrandId] =
    useState<string>("");
  const [selectedProductCapacityId, setSelectedProducttCapacityId] =
    useState<string>("");
  const [selectedProductCategoryId, setSelectedProductCategoryId] =
    useState<string>("");
  const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
    []
  );
  const [selectedMainItemId, setSelectedMainItemId] = useState<string>("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [selectedProductViewOnline, setSelectedProductViewOnline] =
    useState<string>("");
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;
  const [createDate, setCreateDate] = useState<Dayjs | null>(null);
  const [isPaperVisible, setIsPaperVisible] = useState(false);
  const [orderList, setOrderList] = useState<IOrderItem[]>([]);
  const [editData, setEditData] = useState<IOrderItemSetUp | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [quantities, setQuantities] = useState({
    quantityKgOrLi: 0,
    quantitySmallUnit: 0,
  });
  const [openTax, setOpenTax] = useState(false);

  const [openSuppier, setOpenSuppier] = useState(false);
  const [openGrade, setOpenGrade] = useState(false);

  const [openRemarkId, setOpenRemarkId] = useState<string | null>(null);
  const [newOrderList, { isLoading: OrderListIsLoading }] =
    useCreatePriceCheckListMutation();
  const { data: workOrderLastData, isLoading: workOrderIsLoading } =
    useGetLastPriceCheckListIdQuery();

  const { data: categoryData } = useGetAllMainCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
  });

  const {
    data: categoryGetAllData,
    isLoading: categoryGetAllIsLoading,
    isError: categoryGetAllIsError,
    refetch: categoryGetAllRefetch,
  } = useGetAllMainCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
  });

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });
  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const subCategoryList = useMemo(() => {
    return subCategoryData?.data as ICategory[];
  }, [subCategoryData?.data]);

  const subToSubCategoryList = useMemo(() => {
    return subCategory2Data?.data as ICategory[];
  }, [subCategory2Data?.data]);

  const subToSubToSubCategoryList = useMemo(() => {
    return subCategory3Data?.data as ICategory[];
  }, [subCategory3Data?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const restaurantOptions = useMemo(() => {
    if (!Array.isArray(restaurantList)) return [];
    return restaurantList.map((cust) => ({
      label: `${capitalizeFirstLetter(cust.restaurantsName)}`,
      value: cust.id,
    }));
  }, [restaurantList]);

  const categoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");

  const { data, isLoading, isError, refetch } = useGetProductQuery({
    variantBrandId: selectedProductBrandId,
    categoryId: String(categoryId),
    variantTagId: selectedProductTagIds,
    productViewOnline: selectedProductViewOnline,
    createdDateStart: startDateAsDate as Date,
    createdDateEnd: endDateAsDate as Date,
    searchText: currentSearchQuery,
    createdDate: getFormattedDate(createDate),
    id: null,
    mainItemId: selectedMainItemId,
    capacityId: selectedProductCapacityId,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedProduct, setSelectedProduct] = useState<IVariantView | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<IVariantView | null>(
    null
  );

  const { data: coursingData, isLoading: coursingLoading } =
    useGetCategoryQuery();

  const { data: productCategoryData, isLoading: productCategoryLoading } =
    useGetProductCategoryQuery({
      searchText: "",
      isActive: true,
    });

  const { data: productBrandData, isLoading: ProductBrandLoading } =
    useGetBrandQuery({
      searchText: "",
      isActive: "1",
      id: "",
    });

  const { data: productcapacityData, isLoading: capacityIsLoading } =
    useGetCapacityQuery({
      searchText: "",
      isActive: "1",
      id: "",
    });

  const { data: productTagData, isLoading: ProductTagLoading } = useGetTagQuery(
    {
      searchText: "",
      isActive: "1",
      id: "",
    }
  );

  const { data: gradeData, isLoading: gradeIsLoading } = useGetGradeQuery({
    searchText: "",
    isActive: "1",
    id: "",
  });

  const { data: supplierData, isLoading: supplierIsLoading } =
    useGetSupplierQuery({
      searchText: "",
      isActive: "1",
      id: "",
    });

  const { data: mainItemData, isLoading: mainItemIsLoading } =
    useGetMainItemQuery({
      searchText: "",
      id: "",
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
      capacityId: null,
    });

  const coursingList = useMemo(() => {
    return coursingData?.data as ICategory[];
  }, [coursingData?.data]);

  const productList = useMemo(() => {
    return productCategoryData?.data as IProductCategory[];
  }, [productCategoryData?.data]);

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IBrand[];
  }, [productBrandData?.data]);

  const productCapacityList = useMemo(() => {
    return productcapacityData?.data as ICapacity[];
  }, [productcapacityData?.data]);

  const productTagList = useMemo(() => {
    return productTagData?.data as ITag[];
  }, [productTagData?.data]);

  const mainItemList = useMemo(() => {
    return mainItemData?.data as IMainItem[];
  }, [mainItemData?.data]);

  const variantList = useMemo(() => {
    return data?.data as IVariantView[];
  }, [data?.data]);

  const productGradeList = useMemo(() => {
    return gradeData?.data as IGrade[];
  }, [gradeData?.data]);

  const productSupplierList = useMemo(() => {
    return supplierData?.data as ISupplier[];
  }, [supplierData?.data]);

  const coursingMap = useMemo(() => {
    const map = new Map();
    coursingList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [coursingList]);

  const variantOptions = useMemo(() => {
    if (!Array.isArray(variantList)) return [];
    return variantList.map((cust) => ({
      label: `${capitalizeFirstLetter(cust.variantName)}`,
      value: String(cust.id),
    }));
  }, [variantList]);

  const gradeOptions = useMemo(() => {
    if (!Array.isArray(productGradeList)) return [];
    return productGradeList.map((cust) => ({
      label: `${capitalizeFirstLetter(cust.gradeName)}`,
      value: String(cust.id),
    }));
  }, [productGradeList]);

  const supplierOptions = useMemo(() => {
    if (!Array.isArray(productSupplierList)) return [];
    return productSupplierList.map((cust) => ({
      label: `${capitalizeFirstLetter(cust.supplierName)}`,
      value: String(cust.id),
    }));
  }, [productSupplierList]);

  // const handleMainCategoryChange = (
  //   event: React.ChangeEvent<{ value: unknown }>
  // ) => {
  //   const categoryId = event.target.value as number;
  //   setSelectedCategoryId(categoryId);
  //   setSelectedSubCategoryId(null);
  //   setSelectedSubToSubCategoryId(null);
  //   setSelectedSubToSubToSubCategoryId(null);

  //   const selectedCategory = categoryList.find(
  //     (category) => category.id == categoryId
  //   );
  // };

  const handleMainCategoryChange = (event: SyntheticEvent, value: any) => {
    const categoryId = value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = categoryList.find(
      (category) => category.id === categoryId
    );
  };

  const handleSubCategoryChange = (event: SyntheticEvent, value: any) => {
    const subCategoryId = value as number;
    setSelectedSubCategoryId(subCategoryId);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subCategoryList.find(
      (category) => category.id == subCategoryId
    );
  };

  const handleSubToSubCategoryChange = (event: SyntheticEvent, value: any) => {
    const selectedSubToSubCategoryId = value as number;
    setSelectedSubToSubCategoryId(selectedSubToSubCategoryId);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subToSubCategoryList.find(
      (category) => category.id == selectedSubToSubCategoryId
    );
  };

  const handleSubToSubToSubCategoryChange = (
    event: SyntheticEvent,
    value: any
  ) => {
    const selectedSubToSubToSubCategoryId = value as number;
    setSelectedSubToSubToSubCategoryId(selectedSubToSubToSubCategoryId);

    const selectedCategory = subToSubToSubCategoryList.find(
      (category) => category.id == selectedSubToSubToSubCategoryId
    );
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (product: IVariantView) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (product: IVariantView) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  const handleProductBrandChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductBrandId(selectedValues);
  };

  const handleProductCapacityChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProducttCapacityId(selectedValues);
  };

  const handleMainItemChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedMainItemId(selectedValues);
  };

  const handleProductViewOnline = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductViewOnline(selectedValues);
  };

  const handleProductCategory = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductCategoryId(selectedValues);
  };

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const handleCreateDateChange = (newValue: Dayjs | null) => {
    setCreateDate(newValue);
  };
  const toggleRemarkContainer = (productId: string) => {
    setOpenRemarkId(openRemarkId === productId ? null : productId);
  };

  const handleProductTag = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    setSelectedProductTagIds(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [deleteCategory] = useDeleteProductMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProduct(false);
      } else {
        showErrorMessage("Failed to delete the product");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  const handleEditOpen = (row: IVariantView) => {
    const transformedRow: IOrderItemSetUp = {
      productId: row.id,
      variantName: row.variantName,
      variantUnit: row.variantUnit,
      quantityKgOrLi: row.quantityKgOrLi,
      quantitySmallUnit: row.quantitySmallUnit,
      remark: row.remark,
    };

    setEditData(transformedRow);
    setIsEditDialogOpen(true);
  };

  const handleEditClose = () => {
    setEditData(null);
    setIsEditDialogOpen(false);
  };

  // const handleQuantityChange = (
  //   e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   field: keyof IOrderItemSetUp
  // ) => {
  //   const value = Number(e.target.value);

  //   setEditData((prevData) => {
  //     if (!prevData) return null;

  //     return {
  //       ...prevData,
  //       [field]: value,
  //     };
  //   });
  // };

  const handleQuantityChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: keyof IOrderItemSetUp
  ) => {
    const value = field === "remark" ? e.target.value : Number(e.target.value);

    setEditData((prevData) => {
      if (!prevData) return null;

      return {
        ...prevData,
        [field]: value,
      };
    });
  };

  const handleQuantityChangeMain = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string,
    index: number
  ) => {
    // const value = Number(e.target.value);
    const value = field === "remark" ? e.target.value : Number(e.target.value);

    setOrderList((prevOrderList) =>
      prevOrderList.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  const handleDeleteRow = (productId: string) => {
    setOrderList((prevOrderList) =>
      prevOrderList.filter((row) => row.productId !== productId)
    );
  };

  // const handleAddToOrder = (product: IOrderItemSetUp) => {
  //   let totalQuantity = 0;

  //   if (product.variantUnit === 3 || product.variantUnit === 5) {
  //     totalQuantity =
  //       product.quantityKgOrLi +
  //       parseFloat(((product.quantitySmallUnit || 0) / 1000).toFixed(3));
  //   } else {
  //     totalQuantity = product.quantityKgOrLi;
  //   }

  //   const existingItemIndex = orderList.findIndex(
  //     (item) => item.productId === product.productId
  //   );

  //   if (existingItemIndex > -1) {
  //     const updatedOrderList = [...orderList];
  //     updatedOrderList[existingItemIndex].productTotalUnit += totalQuantity;
  //     setOrderList(updatedOrderList);
  //   } else {
  //     setOrderList((prevOrderList) => [
  //       ...prevOrderList,
  //       {
  //         productId: product.productId,
  //         variantName: product.variantName,
  //         variantUnit: product.variantUnit,
  //         productTotalUnit: totalQuantity,
  //         remark: product.remark,
  //       },
  //     ]);
  //   }
  // };

  const handleAddToOrder = (product: IOrderItemSetUp) => {
    let totalQuantity = 0;

    if (product.variantUnit === 3 || product.variantUnit === 5) {
      totalQuantity =
        product.quantityKgOrLi +
        parseFloat(((product.quantitySmallUnit || 0) / 1000).toFixed(3));
    } else {
      totalQuantity = product.quantityKgOrLi;
    }

    const existingItemIndex = orderList.findIndex(
      (item) => item.productId === product.productId
    );

    if (existingItemIndex > -1) {
      const updatedOrderList = [...orderList];

      updatedOrderList[existingItemIndex].productTotalUnit += totalQuantity;

      updatedOrderList[existingItemIndex].remark = product.remark;

      setOrderList(updatedOrderList);
    } else {
      setOrderList((prevOrderList) => [
        ...prevOrderList,
        {
          productId: product.productId,
          variantName: product.variantName,
          variantUnit: product.variantUnit,
          productTotalUnit: totalQuantity,
          remark: product.remark,
        },
      ]);
    }
  };

  // const handleAddToOrder = (product: IProductOrderList) => {
  //   let totalQuantity = 0;

  //   if (product.variantUnit === 3 || product.variantUnit === 5) {
  //     // Convert smaller units if provided
  //     totalQuantity =
  //       quantities.quantityKgOrLi + quantities.quantitySmallUnit / 1000;
  //   } else {
  //     // For other units, use quantity directly
  //     totalQuantity = quantities.quantityKgOrLi;
  //   }

  //   const existingItemIndex = orderList.findIndex(
  //     (item) => item.productId === product.id
  //   );

  //   if (existingItemIndex > -1) {
  //     const updatedOrderList = [...orderList];
  //     updatedOrderList[existingItemIndex].productTotalUnit += totalQuantity;
  //     setOrderList(updatedOrderList);
  //   } else {
  //     setOrderList((prevOrderList) => [
  //       ...prevOrderList,
  //       {
  //         productId: product.id,
  //         variantName: product.variantName,
  //         variantUnit: product.variantUnit,
  //         productTotalUnit: totalQuantity,
  //       },
  //     ]);
  //   }

  //   // Reset quantity fields
  //   setQuantities({ quantityKgOrLi: 0, quantitySmallUnit: 0 });
  // };

  const formik = useFormik<IPriceCheckList>({
    initialValues: {
      variantId: "",
      gradeId: "",
      supplierId: "",
      updatedPrice: null,
      updatedDate: null,
      description: "",
      priceListId: "",
    },

    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          variantId: values.variantId,
          priceListId: values.priceListId,
          gradeId: values.gradeId,
          supplierId: values.supplierId,
          updatedPrice: values.updatedPrice,
          updatedDate: dayjs(values.updatedDate).format("YYYY-MM-DD"),
          description: values.description,
        };
        const addCompanyResponse = await newOrderList(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return (
      formik.values.variantId !== "" &&
      formik.values.variantId !== undefined &&
      formik.values.gradeId !== "" &&
      formik.values.gradeId !== undefined &&
      formik.values.supplierId !== "" &&
      formik.values.supplierId !== null &&
      formik.values.updatedPrice !== null &&
      formik.values.updatedDate !== null
    );
  }, [
    formik.values.variantId,
    formik.values.gradeId,
    formik.values.supplierId,
    formik.values.updatedPrice,
    formik.values.updatedDate,
  ]);

  useEffect(() => {
    if (!variantList || variantList.length === 0) {
      formik.setFieldValue("variantId", "");
      return;
    }

    const exists = variantList.some((v) => v.id === formik.values.variantId);

    if (!exists) {
      formik.setFieldValue("variantId", "");
    }
  }, [variantList]);

  const coursings: IVariantView[] = Array.isArray(data?.data)
    ? (data?.data as IVariantView[])
    : [];

  const resetFields = () => {
    setSelectedProductBrandId("");
    setSelectedProducttCapacityId("");
    setSelectedProductCategoryId("");
    setSelectedProductViewOnline("");
    setSelectedProductTagIds([]);
    setStartDate(null);
    setEndDate(null);
    setCreateDate(null);
    setSelectedCategoryId(null);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    setSearchQuery("");
    setSelectedMainItemId("");
  };

  const handleCancelOrderList = () => {
    formik.setFieldValue("updatedPrice", "");
    formik.resetForm();
  };

  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetSearchFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };

  const handleAddProductClick = () => {
    navigate("/product/create");
  };

  const rawData = workOrderLastData?.data;
  const workOrderId =
    typeof rawData === "number"
      ? rawData
      : parseInt(rawData as string, 10) || 0;

  useEffect(() => {
    if (workOrderId !== null) {
      const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);
      formik.setFieldValue("priceListId", generatedWorkOrderNo);
    }
  }, [workOrderId]);

  if (
    isLoading ||
    coursingLoading ||
    productCategoryLoading ||
    ProductBrandLoading ||
    ProductTagLoading ||
    mainItemIsLoading ||
    workOrderIsLoading ||
    gradeIsLoading ||
    supplierIsLoading ||
    restauramtIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={7} md={6} sm={12} xs={12}>
        <Card className={classes.orderListLeftCard}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ padding: 2, borderBottom: 4 }}
            className={classes.orderListLeftHeader}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CiSearch
                            className={classes.orderListSearchWidgetIcon}
                          />
                        </InputAdornment>
                      ),
                      classes: {
                        root: classes.formControlList,
                      },
                    }}
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Name & Display Name.."
                    className={classes.orderListTextField}
                    size="small"
                    sx={{ minWidth: "300px" }}
                  />
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<FilterAltIcon />}
                    className={classes.ordeListButton}
                    onClick={handleToggle}
                  >
                    {isPaperVisible ? "Close Filter" : "Open Filter"}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    // variant="contained"
                    startIcon={<RefreshIcon />}
                    className={classes.ordeListButton}
                    onClick={resetFields}
                  >
                    Refresh
                  </Button>
                </Grid>
                {userHasRight(Privileges.ThemeView) && (
                  <Grid item>
                    <Button
                      // variant="contained"
                      startIcon={<ColorLensIcon />}
                      className={classes.ordeListButton}
                      onClick={() => {
                        setOpenTax(true);
                      }}
                    >
                      Set Theme
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          {isPaperVisible && (
            <>
              <Grid
                container
                spacing={2}
                my={2}
                px={1}
                sx={{ padding: 2, borderBottom: 4 }}
                className={classes.orderListLeftHeader}
              >
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Product
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        size="small"
                        value={selectedMainItemId || ""}
                        onChange={handleMainItemChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ flexGrow: 1, width: "100%" }}
                        InputProps={{
                          classes: {
                            root: classes.formControlListStatus,
                          },
                        }}
                        className={classes.orderListTextField}
                      >
                        <MenuItem value="" style={{ color: "gray" }}>
                          Select an option
                        </MenuItem>
                        {mainItemList.map((mainitem) => (
                          <MenuItem key={mainitem.id} value={mainitem.id}>
                            {mainitem.mainItemName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>Brand</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        size="small"
                        value={selectedProductBrandId || ""}
                        onChange={handleProductBrandChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ flexGrow: 1, width: "100%" }}
                        InputProps={{
                          classes: {
                            root: classes.formControlListStatus,
                          },
                        }}
                        className={classes.orderListTextField}
                      >
                        <MenuItem value="" style={{ color: "gray" }}>
                          Select an option
                        </MenuItem>
                        {productBrandList.map((productBrand) => (
                          <MenuItem
                            key={productBrand.id}
                            value={productBrand.id}
                          >
                            {productBrand.brandName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Capacity
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        size="small"
                        value={selectedProductCapacityId || ""}
                        onChange={handleProductCapacityChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ flexGrow: 1, width: "100%" }}
                        InputProps={{
                          classes: {
                            root: classes.formControlListStatus,
                          },
                        }}
                        className={classes.orderListTextField}
                      >
                        <MenuItem value="" style={{ color: "gray" }}>
                          Select an option
                        </MenuItem>
                        {productCapacityList.map((productBrand) => (
                          <MenuItem
                            key={productBrand.id}
                            value={productBrand.id}
                          >
                            {productBrand.capacityName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>Tag</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        size="small"
                        SelectProps={{
                          multiple: true,
                          native: false,
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={selectedProductTagIds || ""}
                        onChange={handleProductTag}
                        sx={{ flexGrow: 1, width: "100%" }}
                        InputProps={{
                          classes: {
                            root: classes.formControlListStatus,
                          },
                        }}
                        className={classes.orderListTextField}
                      >
                        {productTagList && productTagList.length > 0 ? (
                          productTagList.map((productTag: ITag) => (
                            <MenuItem key={productTag.id} value={productTag.id}>
                              {productTag.tagName}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="" style={{ color: "gray" }}>
                            Select an option
                          </MenuItem>
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Create Date
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleCreateDateChange}
                          value={createDate}
                          className={classes.orderListTextField}
                          slotProps={{
                            textField: {
                              placeholder: "Create Date",
                              size: "small",
                              sx: {
                                width: "140px",
                              },
                              InputProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                                // classes: {
                                //   // root: classes.textFieldQuote,
                                // },
                                classes: {
                                  root: classes.formControlListStatus,
                                },
                              },
                              InputLabelProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Start Date
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleStartDateChange}
                          value={startDate}
                          className={classes.orderListTextField}
                          slotProps={{
                            textField: {
                              placeholder: "Start Date",
                              size: "small",
                              sx: {
                                width: "140px",
                              },
                              InputProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                                // classes: {
                                //   // root: classes.textFieldQuote,
                                // },
                                classes: {
                                  root: classes.formControlListStatus,
                                },
                              },
                              InputLabelProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        End Date
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleEndDateChange}
                          value={endDate}
                          className={classes.orderListTextField}
                          slotProps={{
                            textField: {
                              placeholder: "Price Updated Date",
                              size: "small",
                              sx: { width: "100%" },
                              InputProps: {
                                sx: {
                                  fontSize: 14,
                                },
                                classes: {
                                  root: classes.formControlListStatus,
                                },
                              },
                              InputLabelProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Button
                        // variant="contained"
                        startIcon={<RefreshIcon />}
                        className={classes.ordeListButton}
                        onClick={resetFields}
                      >
                        Refresh
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        startIcon={<FilterAltIcon />}
                        className={classes.ordeListButton}
                        onClick={handleToggle}
                      >
                        {isPaperVisible ? "Close" : "Open"}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Box>
                    <Tabs
                      value={selectedCategoryId || ""}
                      onChange={handleMainCategoryChange}
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                      aria-label="scrollable force tabs example"
                      sx={{
                        borderBottom: 1,
                        [`& .${tabsClasses.scrollButtons}`]: {
                          "&.Mui-disabled": { opacity: 0.3 },
                        },
                        "& .MuiTabs-scrollButtons svg": {
                          fontSize: 40,
                          color: "black",
                        },
                      }}
                      className={classes.orderListRightHeader2}
                    >
                      {categoryList &&
                        categoryList.map((category) => (
                          <Tab
                            key={category.id}
                            value={category.id}
                            label={
                              <Box
                                className={
                                  selectedCategoryId === category.id
                                    ? classes.orderListTabButtonSelect
                                    : classes.orderListTabButton
                                }
                              >
                                <ClassRoundedIcon />
                                <Typography
                                  sx={{
                                    px: 1,
                                  }}
                                  className={classes.tabTypograpy}
                                >
                                  {category.categoryName}
                                </Typography>
                              </Box>
                            }
                          />
                        ))}
                    </Tabs>
                  </Box>
                </Grid>
                {selectedCategoryId && subCategoryList.length > 0 && (
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignContent={"center"}
                  >
                    <Box>
                      <Tabs
                        value={
                          selectedSubCategoryId === null
                            ? ""
                            : selectedSubCategoryId
                        }
                        onChange={handleSubCategoryChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs example"
                        sx={{
                          borderBottom: 1,
                          [`& .${tabsClasses.scrollButtons}`]: {
                            "&.Mui-disabled": { opacity: 0.3 },
                          },
                          "& .MuiTabs-scrollButtons svg": {
                            fontSize: 40,
                            color: "black",
                          },
                        }}
                        className={classes.orderListRightHeader2}
                      >
                        {subCategoryList &&
                          subCategoryList.map((category) => (
                            <Tab
                              key={category.id}
                              value={category.id}
                              label={
                                <Box
                                  className={
                                    selectedSubCategoryId === category.id
                                      ? classes.orderListTabButtonSelect
                                      : classes.orderListTabButton
                                  }
                                >
                                  <ClassRoundedIcon />
                                  <Typography
                                    sx={{
                                      px: 1,
                                    }}
                                    className={classes.tabTypograpy}
                                  >
                                    {category.categoryName}
                                  </Typography>
                                </Box>
                              }
                            />
                          ))}
                      </Tabs>
                    </Box>
                  </Grid>
                )}
                {selectedCategoryId &&
                  selectedSubCategoryId &&
                  subToSubCategoryList.length > 0 && (
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                    >
                      <Box>
                        <Tabs
                          value={
                            selectedSubToSubCategoryId === null
                              ? ""
                              : selectedSubToSubCategoryId
                          }
                          onChange={handleSubToSubCategoryChange}
                          variant="scrollable"
                          scrollButtons
                          allowScrollButtonsMobile
                          aria-label="scrollable force tabs example"
                          sx={{
                            borderBottom: 1,

                            [`& .${tabsClasses.scrollButtons}`]: {
                              "&.Mui-disabled": { opacity: 0.3 },
                            },
                            "& .MuiTabs-scrollButtons svg": {
                              fontSize: 40,
                              color: "black",
                            },
                          }}
                          className={classes.orderListRightHeader2}
                        >
                          {subToSubCategoryList &&
                            subToSubCategoryList.map((category) => (
                              <Tab
                                key={category.id}
                                value={category.id}
                                label={
                                  <Box
                                    className={
                                      selectedSubToSubCategoryId === category.id
                                        ? classes.orderListTabButtonSelect
                                        : classes.orderListTabButton
                                    }
                                  >
                                    <ClassRoundedIcon />
                                    <Typography
                                      sx={{
                                        px: 1,
                                      }}
                                      className={classes.tabTypograpy}
                                    >
                                      {category.categoryName}
                                    </Typography>
                                  </Box>
                                }
                              />
                            ))}
                        </Tabs>
                      </Box>
                    </Grid>
                  )}
                {selectedCategoryId &&
                  selectedSubCategoryId &&
                  selectedSubToSubCategoryId &&
                  subToSubToSubCategoryList.length > 0 && (
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                    >
                      <Box>
                        <Tabs
                          value={
                            selectedSubToSubToSubCategoryId === null
                              ? ""
                              : selectedSubToSubToSubCategoryId
                          }
                          onChange={handleSubToSubToSubCategoryChange}
                          variant="scrollable"
                          scrollButtons
                          allowScrollButtonsMobile
                          aria-label="scrollable force tabs example"
                          sx={{
                            borderBottom: 1,
                            [`& .${tabsClasses.scrollButtons}`]: {
                              "&.Mui-disabled": { opacity: 0.3 },
                            },
                            "& .MuiTabs-scrollButtons svg": {
                              fontSize: 40,
                              color: "black",
                            },
                          }}
                          className={classes.orderListRightHeader2}
                        >
                          {subToSubToSubCategoryList &&
                            subToSubToSubCategoryList.map((category) => (
                              <Tab
                                key={category.id}
                                value={category.id}
                                label={
                                  <Box
                                    className={
                                      selectedSubToSubToSubCategoryId ===
                                      category.id
                                        ? classes.orderListTabButtonSelect
                                        : classes.orderListTabButton
                                    }
                                  >
                                    <ClassRoundedIcon />
                                    <Typography
                                      sx={{
                                        px: 1,
                                      }}
                                      className={classes.tabTypograpy}
                                    >
                                      {category.categoryName}
                                    </Typography>
                                  </Box>
                                }
                              />
                            ))}
                        </Tabs>
                      </Box>
                    </Grid>
                  )}
              </Grid>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              {isError ? (
                <Grid container justifyContent="center" sx={{ padding: 2 }}>
                  <Typography>Error fetching data</Typography>
                </Grid>
              ) : isLoading ? (
                <Grid container justifyContent="center" sx={{ padding: 2 }}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="10vh"
                  >
                    <CircularProgress />
                  </Box>
                </Grid>
              ) : coursings.length === 0 ? (
                <Grid container justifyContent="center" sx={{ padding: 2 }}>
                  <Typography>No data available</Typography>
                </Grid>
              ) : (
                <Box
                  sx={{
                    height: "90vh",
                    overflow: "auto",
                    padding: "2px",
                    "&::-webkit-scrollbar": {
                      width: "4px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#eeeeee",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#eeeeee",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#eeeeee",
                    },
                  }}
                >
                  <Grid container spacing={3} sx={{ padding: 2 }}>
                    {coursings.map((row: IVariantView, index) => (
                      <Grid item lg={3} md={6} sm={6} xs={12} key={row.id}>
                        <Card
                          className={classes.orderListFormikProductCard}
                          // sx={{ padding: 2, height: "100%", cursor: "pointer" }}
                          // onClick={() => handleEditOpen(row)}
                          sx={{
                            padding: 2,
                            height: "100%",
                            cursor: !row.variantUnit ? "pointer" : "pointer",
                            border:
                            String(row.id) === formik.values.variantId
                              ? `5px solid ${theme.palette.orderListProp.headingColor}`
                              : "none",
                          boxShadow:
                            String(row.id) === formik.values.variantId
                              ? "0 0 8px rgba(0, 0, 0, 0.15)"
                              : "none",
                          }}
                          onClick={() => {
                            formik.setFieldValue("variantId", String(row.id));
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              textAlign="center"
                            >
                              <Grid
                                container
                                textAlign="center"
                                justifyContent={"center"}
                              >
                                <Grid
                                  item
                                  textAlign="center"
                                  className={
                                    classes.SelectImageTableBoxwithBorder2
                                  }
                                >
                                  {row.variantImg ? (
                                    <img
                                      src={row.variantImg}
                                      alt="img"
                                      // alt={row.variantName.toLowerCase()}
                                      className={classes.SelectImageTable70}
                                    />
                                  ) : (
                                    <ProductionQuantityLimitsIcon
                                      className={classes.SelectImageTable}
                                    />
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              textAlign="center"
                            >
                              {/* <Typography
                                className={classes.productCardTypograpy}
                              >
                                {row.variantName.length > 50
                                  ? `${row.variantName.slice(0, 50)}...`
                                  : row.variantName}
                              </Typography> */}
                              {row.variantName.length > 50 ? (
                                <Tooltip
                                  title={
                                    <>
                                      <Typography variant="body2">
                                        <strong>{row.variantName}</strong>
                                      </Typography>
                                    </>
                                  }
                                  sx={{ fontSize: "14px" }}
                                >
                                  <Typography
                                    className={classes.productCardTypograpy}
                                  >
                                    {`${row.variantName.slice(0, 50)}...`}
                                  </Typography>
                                </Tooltip>
                              ) : (
                                <Typography
                                  className={classes.productCardTypograpy}
                                >
                                  {row.variantName}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}
            </Grid>
          </Grid>
        </Card>
      </Grid>

      <Grid item lg={5} md={6} sm={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.orderListRightCard2}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 2, borderBottom: 4 }}
                className={classes.oLRightHeader}
              >
                <Grid
                  item
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Typography className={classes.orderLsitHeadingTypo}>
                        {formik.values.priceListId}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}></Grid>
            </Card>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.orderListRightCard}>
              <Box
                sx={{
                  height: "80vh",
                  overflow: "auto",
                  padding: "2px",
                  "&::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#eeeeee",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#eeeeee",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#eeeeee",
                  },
                }}
              >
                <Grid container spacing={2} p={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className={classes.oLFormiklHeader}>
                          Item <span className={classes.requiedfield}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Autocomplete
                          options={variantOptions}
                          loading={isLoading}
                          getOptionLabel={(option: CustomerOptionString) =>
                            option.label
                          }
                          value={
                            variantOptions.find(
                              (opt) =>
                                opt.value === String(formik.values.variantId)
                            ) || null
                          }
                          onChange={(
                            _,
                            newValue: CustomerOptionString | null
                          ) => {
                            formik.setFieldValue(
                              "variantId",
                              newValue?.value || ""
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Grade"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              className={classes.orderListTextField}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {restauramtIsLoading ? (
                                      <CircularProgress size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className={classes.oLFormiklHeader}>
                          Grade <span className={classes.requiedfield}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={10.5} md={10.5} sm={10.5} xs={10.5}>
                        <Autocomplete
                          options={gradeOptions}
                          loading={gradeIsLoading}
                          getOptionLabel={(option: CustomerOptionString) =>
                            option.label
                          }
                          value={
                            gradeOptions.find(
                              (opt) =>
                                opt.value === String(formik.values.gradeId)
                            ) || null
                          }
                          onChange={(
                            _,
                            newValue: CustomerOptionString | null
                          ) => {
                            formik.setFieldValue(
                              "gradeId",
                              newValue?.value || ""
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Grade"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              className={classes.orderListTextField}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {restauramtIsLoading ? (
                                      <CircularProgress size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                      <Grid
                        item
                        lg={1.5}
                        md={1.5}
                        sm={1.5}
                        xs={1.5}
                        display="flex"
                        sx={{
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          textAlign: "end",
                        }}
                      >
                        <Button
                          variant="contained"
                          className={classes.editFormikButton}
                          onClick={() => {
                            setOpenGrade(true);
                          }}
                        >
                          <AddIcon />
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className={classes.oLFormiklHeader}>
                          Supplier{" "}
                          <span className={classes.requiedfield}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={10.5} md={10.5} sm={10.5} xs={10.5}>
                        <Autocomplete
                          options={supplierOptions}
                          loading={supplierIsLoading}
                          getOptionLabel={(option: CustomerOptionString) =>
                            option.label
                          }
                          value={
                            supplierOptions.find(
                              (opt) =>
                                opt.value === String(formik.values.supplierId)
                            ) || null
                          }
                          onChange={(
                            _,
                            newValue: CustomerOptionString | null
                          ) => {
                            formik.setFieldValue(
                              "supplierId",
                              newValue?.value || ""
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Supplier"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              className={classes.orderListTextField}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {restauramtIsLoading ? (
                                      <CircularProgress size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                      <Grid
                        item
                        lg={1.5}
                        md={1.5}
                        sm={1.5}
                        xs={1.5}
                        display="flex"
                        sx={{
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          textAlign: "end",
                        }}
                      >
                        <Button
                          variant="contained"
                          className={classes.editFormikButton}
                          onClick={() => {
                            setOpenSuppier(true);
                          }}
                        >
                          <AddIcon />
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className={classes.oLFormiklHeader}>
                          Price <span className={classes.requiedfield}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Price"
                          size="small"
                          type="number"
                          //   {...formik.getFieldProps("updatedPrice")}
                          //   value={formik.values.updatedPrice ?? ""}
                          //   onChange={formik.handleChange}

                          name="updatedPrice"
                          value={formik.values.updatedPrice ?? ""} // ✅ convert null ➜ ""
                          onChange={(e) => {
                            formik.setFieldValue(
                              "updatedPrice",
                              e.target.value === "" ? null : e.target.value
                            );
                          }}
                          className={classes.orderListTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className={classes.oLFormiklHeader}>
                          Date <span className={classes.requiedfield}>*</span>
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={formik.values.updatedDate}
                            onChange={(date) =>
                              formik.setFieldValue("updatedDate", date)
                            }
                            className={classes.orderListTextField}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: { width: "100%" },
                                InputProps: {
                                  sx: { fontSize: 14 },
                                },
                                InputLabelProps: {
                                  sx: { fontSize: 14 },
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className={classes.oLFormiklHeader}>
                          Description
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Description"
                          size="small"
                          multiline
                          rows={7}
                          {...formik.getFieldProps("description")}
                          className={classes.orderListTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                p={1}
                pt={5}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="contained"
                  startIcon={
                    OrderListIsLoading ? (
                      <CircularProgress
                        size={18}
                        className={classes.isLoading}
                      />
                    ) : (
                      <AddIcon />
                    )
                  }
                  className={classes.oLConformButton}
                  onClick={() => formik.handleSubmit()}
                  disabled={!formValid || OrderListIsLoading}
                >
                  Create Check List
                </Button>
              </Grid>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                p={1}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="outlined"
                  startIcon={<CloseIcon />}
                  className={classes.oLOCancelButton}
                  //   onClick={() => formik.resetForm()}
                  onClick={handleCancelOrderList}
                >
                  Clear
                </Button>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      {openSuppier && (
        <NewProductSupplier
          handleCloseDialog={() => setOpenSuppier(false)}
          openModel={openSuppier}
        />
      )}

      {openGrade && (
        <NewProductGrade
          handleCloseDialog={() => setOpenGrade(false)}
          openModel={openGrade}
        />
      )}

      {openTax && (
        <NewColor
          handleCloseDialog={() => setOpenTax(false)}
          openModel={openTax}
        />
      )}

      {selectedProduct && (
        <NewPopUpProduct
          openModel={openDialog}
          handleCloseDialog={handleCloseDialog}
          data={selectedProduct}
        />
      )}
    </Grid>
  );
};

export default Index;
